import React, { FC, useEffect, useState, memo } from 'react';
import { getTimeDifference } from 'utils/helpers/momentTime';
import moment from 'moment';
import { IEvents } from 'types';
import eventStyles from '../../calendar/index.module.scss';

const PX_IN_MIN = 1.33;

interface IEventProps {
  day: moment.Moment;
  event: IEvents;
  diff: number;
}

const Event: FC<IEventProps> = ({ event, day, diff }) => {
  const diffInTime = getTimeDifference(
    moment(event.startTime, 'YYYY-MM-DD HH:mm'),
    event.startTimeStr || '00:00',
    event.endTimeStr || '00:00',
    moment(event.endTime, 'YYYY-MM-DD HH:mm')
  );
  const [eventHeight, setEventHeight] = useState<number>(
    diffInTime * PX_IN_MIN
  );

  useEffect(() => {
    const height = diffInTime * PX_IN_MIN;
    setEventHeight(height);
  }, [event, day, diffInTime]);

  return (
    <div className={`${eventStyles.cell}`}>
      <div style={{ height: eventHeight, top: `${PX_IN_MIN * diff}px` }}>
        <div
          style={{ height: eventHeight, top: `${PX_IN_MIN * diff}px` }}
          className={eventStyles.eventView}
        >
          <div>
            <div>
              <span>{`${event.subject} `}</span>
              {event.link && <a href={event.link}>{event.link}</a>}
            </div>
            <span>{`${moment(event.startTimeStr, 'HH:mm').format(
              'LT'
            )} - ${moment(event.endTimeStr, 'HH:mm').format('LT')}`}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(Event);
